/** Common international dial codes for WhatsApp number entry (digits only, no +). */
export const WA_DIAL_PREFIXES = [
  { label: 'Italy (+39)', value: '39' },
  { label: 'Albania (+355)', value: '355' },
  { label: 'Germany (+49)', value: '49' },
  { label: 'France (+33)', value: '33' },
  { label: 'Switzerland (+41)', value: '41' },
  { label: 'Austria (+43)', value: '43' },
  { label: 'Spain (+34)', value: '34' },
  { label: 'United Kingdom (+44)', value: '44' },
  { label: 'United States (+1)', value: '1' },
  { label: 'Netherlands (+31)', value: '31' },
  { label: 'Belgium (+32)', value: '32' },
  { label: 'Portugal (+351)', value: '351' },
  { label: 'Greece (+30)', value: '30' },
  { label: 'Romania (+40)', value: '40' },
  { label: 'Poland (+48)', value: '48' },
  { label: 'Croatia (+385)', value: '385' },
  { label: 'Slovenia (+386)', value: '386' },
  { label: 'Serbia (+381)', value: '381' },
  { label: 'North Macedonia (+389)', value: '389' },
  { label: 'Bosnia (+387)', value: '387' },
  { label: 'Montenegro (+382)', value: '382' },
  { label: 'Kosovo (+383)', value: '383' },
  { label: 'Turkey (+90)', value: '90' },
  { label: 'Morocco (+212)', value: '212' },
  { label: 'Tunisia (+216)', value: '216' },
];

export const DEFAULT_WA_DIAL_PREFIX = '39';

export function digitsOnly(raw) {
  if (raw == null) return '';
  return String(raw).replace(/\D/g, '');
}

/**
 * Build stored wa_id digits: country prefix + national number (no leading 0 on national part).
 */
export function composeWaListNumber(prefix, localNumber) {
  const local = digitsOnly(localNumber);
  if (!local) return '';
  if (local.length >= 11 && local.startsWith('00')) {
    return local.slice(2);
  }
  const p = digitsOnly(prefix) || DEFAULT_WA_DIAL_PREFIX;
  if (local.length >= 10 && local.startsWith(p)) {
    return local;
  }
  const national = local.replace(/^0+/, '');
  return p + national;
}
